import { FC } from 'react';
import { ErrorState } from '@bp/ui-components';
import { useNavigate } from 'react-router-dom';
import { PageLayoutPlaceholder } from 'components/PageLayoutPlaceholder/PageLayoutPlaceholder';

export const PageNotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <PageLayoutPlaceholder>
      <ErrorState type='notFound' useLightColor onNavigateBack={() => navigate(-1)} showBackButton />
    </PageLayoutPlaceholder>
  );
};
